import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { useSetPerPage } from "@/methods/kayttajaComposables"
import { ref } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'ComPagination',
  props: /*@__PURE__*/_mergeModels({ total: Number, pageSize: Number }, {
    "currentPage": { default: 1 },
    "currentPageModifiers": {},
  }),
  emits: ["update:currentPage"],
  setup(__props) {

const props = __props
const currentPage = _useModel<number>(__props, "currentPage")
const pageSizes = ref([10, 30, 60, 100])
const { setPerPage } = useSetPerPage()

const pageSizeUpdate = (value : number) => {
    currentPage.value = 1

    if(!value) {
        return
    }

    setPerPage(value)
}

return (_ctx: any,_cache: any) => {
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (__props.total)
    ? (_openBlock(), _createBlock(_component_el_pagination, {
        key: 0,
        layout: "total, prev, pager, next, sizes",
        total: __props.total,
        "page-size": __props.pageSize,
        "current-page": currentPage.value,
        "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => ((currentPage).value = $event)),
        "page-sizes": pageSizes.value,
        size: "small",
        "onUpdate:pageSize": pageSizeUpdate
      }, null, 8, ["total", "page-size", "current-page", "page-sizes"]))
    : _createCommentVNode("", true)
}
}

})